import React from "react";
import { Modal, Typography, Button, Box } from "@mui/material";
import styled from "@emotion/styled";

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2rem;
`;

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

interface Props {
    open?: boolean;
    text?: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: ((evt: React.SyntheticEvent) => void) | (() => void);
    onCancel?: (evt?: React.SyntheticEvent | undefined) => void;
}

const Confirm = (props: Props) => {
    return (
        (props.open && (
            <Modal open={true}>
                <Box sx={style}>
                    <Typography variant="h6" component="h3">
                        {props.text || "Are you sure?"}
                    </Typography>
                    <Row>
                        <Button onClick={props.onCancel}>
                            {props.cancelText || "Cancel"}
                        </Button>
                        <Button
                            onClick={(evt: React.SyntheticEvent) => {
                                props.onConfirm && props.onConfirm(evt);
                            }}
                        >
                            {props.confirmText || "Confirm"}
                        </Button>
                    </Row>
                </Box>
            </Modal>
        )) ||
        null
    );
};

export default Confirm;
